import React, { useState } from "react";

export default function CreateRoleModal({ roles, onClose, onCreate }) {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [baseRoleId, setBaseRoleId] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const body = { name, description };
      if (baseRoleId) {
        const base = roles.find((role) => role.id === baseRoleId);
        if (base) body.permissions = base.permissions;
      }
      await onCreate(body);
      onClose();
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="rm-dialog-overlay" role="dialog" aria-modal="true">
      <div className="rm-dialog rm-modal-content">
        <div className="rm-dialog-head">
          <h2>Create New Role</h2>
          <button
            className="rm-close-btn"
            type="button"
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>
        </div>
        <form onSubmit={handleSubmit} className="rm-create-form">
          <div className="rm-dialog-body">
            <p className="rm-subtext">
              Create a new role and assign permissions.
            </p>
            <input
              placeholder="Role Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
            <span style={{ marginRight: 10 }}></span>
            <input
              placeholder="Description (optional)"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
            <div style={{ marginBottom: 10 }}></div>
            <div className="rm-copy-from">
              <label>Start with permissions from:</label>
              <select
                value={baseRoleId}
                onChange={(e) => setBaseRoleId(e.target.value)}
              >
                <option value="">Blank (no permissions)</option>
                {roles
                  .filter((role) => !role.isSystem)
                  .map((role) => (
                    <option key={role.id} value={role.id}>
                      {role.name}
                    </option>
                  ))}
              </select>
            </div>
          </div>
          <div className="rm-dialog-footer">
            <div className="rm-action-row">
              <button
                className="rm-btn-primary"
                type="submit"
                disabled={loading || !name.trim()}
              >
                {loading ? "Creating..." : "Create Role"}
              </button>
              <button
                className="rm-btn-secondary"
                type="button"
                onClick={onClose}
                disabled={loading}
              >
                Cancel
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
